import {usePage} from "@inertiajs/vue3";
import { createGtm } from '@gtm-support/vue-gtm';

export function initializeEngageBayChat() {
    const engageBayApiKey = import.meta.env.VITE_ENGAGEBAY_JS_KEY;
    const engageBayAccountName = import.meta.env.VITE_ENGAGEBAY_ACCOUNT_NAME;

    setTimeout(() => {
        window.EhAPI = {};

        EhAPI.after_load = function () {
            EhAPI.set_account(engageBayApiKey, engageBayAccountName);
            EhAPI.execute('rules');
        };

        (function (d, s, f) {
            var sc = document.createElement(s);
            sc.type = 'text/javascript';
            sc.async = true;
            sc.src = f;
            var m = d.getElementsByTagName(s)[0];
            m.parentNode.insertBefore(sc, m);
        })(document, 'script', '//d2p078bqz5urf7.cloudfront.net/jsapi/ehform.js?v' + new Date().getHours());
    }, 100);
}

export function initializeClarity() {
    // Clarity removed - function kept for backward compatibility
}

export function initializeFaceBookMetaPixel() {
    let fbPixelId = usePage().props.config.services.facebook_pixel;
    !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', fbPixelId);
    fbq('track', 'PageView');

    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${fbPixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
}

export function initializeHotjar() {
    // Hotjar removed - function kept for backward compatibility
}

export function initializeGTM() {
    let gtmId = usePage().props.config.services.google_tag_manager;
    createGtm({
        id: gtmId,
    })
}

export function initializeThirdPartyPackages() {
    initializeEngageBayChat();
    // initializeClarity(); // Removed
    // initializeHotjar(); // Removed
    initializeGTM();
}

export const openEngageBayChatBox = (message = null) => {
    let page = usePage();

    EhLiveChat.open_chat();

    setTimeout(function() {
        const iframe = document.querySelector('iframe.engagebay-messenger-frame');
        if (iframe) {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

            // Ensure the iframe document is accessible
            if (iframeDocument) {
                // You need to find the correct form fields in the iframe
                const nameField = iframeDocument.querySelector('input[name="name"]');
                const emailField = iframeDocument.querySelector('input[name="email"]');
                const messageField = iframeDocument.querySelector('textarea[name="message"]');

                // Set the values if the fields exist
                if (nameField) nameField.value = page.props.auth.user.name;
                if (emailField) emailField.value = page.props.auth.user.email;
                if (messageField && message) {
                    messageField.value = message;
                    messageField.style.fieldSizing = 'content';
                }
            } else {
                console.error('Cannot access iframe document.');
            }
        } else {
            console.error('Iframe not found.');
        }
    }, 5 * 100);
}

// Open EngageBay ChatBox for trafficID
export const openEngageBayChatBoxForTrafficID = () => {
    openEngageBayChatBox(); // Add message If Needed.
}
